import axios from 'axios';
import { getTokenCredentials } from '../../../Shared/functions';
import { BASE_API } from '../../../Shared/Constants';

export function getRanges(body){
    return axios.post(BASE_API + 'api/list/getlist', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
    });
}

export function getOfficials(body){
    return axios.post(BASE_API + 'api/official/getlist', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
    });
}

export function newOfficial(body) {
    return axios.post(BASE_API + 'api/official/register', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        return error;
    });
}